import { render, staticRenderFns } from "./Blogbook.vue?vue&type=template&id=43a54253&scoped=true&"
import script from "./Blogbook.vue?vue&type=script&lang=js&"
export * from "./Blogbook.vue?vue&type=script&lang=js&"
import style0 from "./Blogbook.vue?vue&type=style&index=0&id=43a54253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a54253",
  null
  
)

export default component.exports